import { EventBus, EVENTS } from '@/services/events/EventBus'

const actionHandler = () => {
  return {
    props: {
      action_type: {
        type: [Object, Boolean],
        default: false
      },
      action_page: {
        type: [Object, Boolean],
        default: false
      },
      action_external_link: {
        type: [Object, Boolean],
        default: false
      },
      action_modal: {
        type: [Object, Boolean],
        default: false
      },
      action_location: {
        type: [Object, Boolean],
        default: false
      }
    },
    methods: {
      handleAction () {
        console.log('handleAction()::', this.action_type.value)
        if (!this.action_type) {
          return false
        }
        switch (this.action_type.value) {
          case 'internal_link':
            return this.$router.push(this.action_page.url)
          break;
          case 'external_link':
            return window.open(this.action_external_link, '_blank')
          break;
          case 'chat':
            EventBus.$emit(EVENTS.OpenChat)
          break;
          case 'modal':
            EventBus.$emit(EVENTS.OpenModal, this.action_modal)
          break;
          case 'wayfinder':
            EventBus.$emit(EVENTS.OpenWayfinder, this.action_location)
          break;
          case 'friend_access':
            return this.$router.push({name: 'settings.invitefriend'})
            break;

          case 'logout':
            this.logout ()
          case 'checkin':
            // TODO: Open check-in
          break;
          default:
            console.error('No handling available for: ', this.action_type)
        }
      },
      async logout () {
      if (confirm('Are you sure you want to log out?')) {
        const response = await this.$store.dispatch('userprofile/logout')
        if (response) {
          return this.$router.replace({name: 'auth.login'})
        }
      }
    },
    }
  }
}

export default actionHandler()
